
// import { useNavigate } from 'react-router-dom';
// import { useAnalytics } from '@/hooks/useAnalytics';
// import { useConversionTracking } from '@/hooks/useConversionTracking';

const HeaderV4 = () => {
  // const navigate = useNavigate();
  // const { trackCTAClick, trackOnboardingStart } = useAnalytics();
  // const { trackCTAPerformance } = useConversionTracking();

  const handleGetEarlyAccess = () => {
    // trackCTAClick('header');
    // trackOnboardingStart();
    // trackCTAPerformance('header-cta', 'click', 'header_button');
    // navigate('/early-access');
    window.location.href = '/early-access';
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-gradient-to-r from-purple-600/90 to-indigo-600/90 backdrop-blur-sm">
      <div className="container max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center shadow-lg">
              <img 
                src="/lovable-uploads/3848e4a0-cee7-43d6-81a6-66811064660c.png" 
                alt="Show Up! Logo"
                className="w-8 h-8 object-contain mix-blend-multiply"
                style={{ filter: 'drop-shadow(0 0 0 transparent)' }}
              />
            </div>
            <h1 className="text-2xl font-black text-white">Show Up!</h1>
          </div>
          
          <button
            onClick={handleGetEarlyAccess}
            className="bg-yellow-400 hover:bg-yellow-300 text-purple-900 font-black px-6 py-3 rounded-xl shadow-lg hover:scale-105 transition-all duration-300 text-sm md:text-base cta"
            data-track="header-cta"
          >
            Get Early Access
          </button>
        </div>
      </div>
    </header>
  );
};

export default HeaderV4;
